/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Parameters for post-session LiveKit oral exam transcription.
 */
export interface OralExamTranscribeJobParams {
  courseId: string;
  moduleId: string;
  taskId: string;
  studentId: string;
  bookingId: string;
  blobPath: string;
  blobPaths?: string[];
}
